import React from 'react'

import { generateModifierClasses } from '../../modules/utils'

const BlockBody = function ({ children, modifiers }) {
  return <div className={generateModifierClasses('block__body', modifiers)}>{children}</div>
}

export default BlockBody
